import { useState } from "react";
import { faqs } from "@/mocks/site/content";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-20 md:py-28 bg-[#FAF5EC]">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="text-xs uppercase tracking-[0.18em] text-brand-600 font-bold mb-3">
            Frequently asked
          </div>
          <h4 className="font-display text-3xl md:text-5xl font-bold text-ink-900 leading-tight tracking-tight">
            <a href="#faq" className="text-ink-900 hover:text-ink-900 no-underline">
              Answers to the stuff everyone wants to know.
            </a>
          </h4>
        </div>

        <div id="faq" className="space-y-3">
          {faqs.map((item, i) => {
            const isOpen = openIndex === i;
            return (
              <div
                key={i}
                className={`rounded-xl border transition-colors ${
                  isOpen ? "border-brand-500 bg-white" : "border-ink-100 bg-white hover:border-ink-300"
                }`}
              >
                <button
                  onClick={() => setOpenIndex(isOpen ? null : i)}
                  className="w-full flex items-center justify-between gap-4 text-left px-5 md:px-6 py-5 cursor-pointer"
                >
                  <span className="font-display text-base md:text-lg font-bold text-ink-900 pr-2">
                    {item.q}
                  </span>
                  <span
                    className={`flex-shrink-0 w-9 h-9 flex items-center justify-center rounded-full transition-all ${
                      isOpen ? "bg-brand-500 text-white rotate-45" : "bg-cream-100 text-ink-700"
                    }`}
                  >
                    <i className="ri-add-line text-lg"></i>
                  </span>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    isOpen ? "max-h-60" : "max-h-0"
                  }`}
                >
                  <div className="px-5 md:px-6 pb-5 -mt-1 text-sm text-ink-600 leading-relaxed">
                    {item.a}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}